import { isRequestError, isWebErrorContent } from '@app/libs/request';

export const SUPPLIER_REGISTRATION_PATTERNS = {
  registrationNumber: /^SV-\d{7,20}$/,
};

export const SUPPLIER_REGISTRATION_MESSAGES = {
  malformedRegistrationNumber: 'Invalid registration number, must be in the format SV-XXXXXXXX',
  // A well-formed number that no supplier validation was ever issued under. The server answers the
  // warnings call with SUPPLIER_VALIDATION_PROCESS_DOES_NOT_EXIST; this reads as a field error
  // rather than a support code because the value is the user's to correct.
  unknownRegistrationNumber: 'Registration number not found, no supplier validation exists with this number',
};

// Every server call that resolves a registration number answers with this code when the number is
// well-formed but no supplier validation was ever issued under it.
export function isUnknownRegistrationNumberError(e: unknown): boolean {
  return (
    isRequestError(e) &&
    isWebErrorContent(e.responseJSON) &&
    e.responseJSON.error === 'SUPPLIER_VALIDATION_PROCESS_DOES_NOT_EXIST'
  );
}
